var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJuicer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1646 6.32918C17.1777 6.32263 17.1909 6.3165 17.2042 6.31079L17.7819 3.18155C17.8954 2.56693 17.4235 2 16.7985 2H7.20153C6.57653 2 6.10468 2.56693 6.21815 3.18155L6.7463 6.04238C8.55878 5.21311 10.6691 5.32679 12.3859 6.35688C13.7231 7.1592 15.3775 7.22273 16.7723 6.52534L17.1646 6.32918Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24891 14.1815C8.33646 14.6558 8.75002 15 9.23229 15H14.7677C15.25 15 15.6636 14.6558 15.7511 14.1815L16.8707 8.11727C15.149 8.76659 13.2113 8.60142 11.6141 7.64312C10.2769 6.8408 8.62252 6.77727 7.22773 7.47466L7.02905 7.574L8.24891 14.1815Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07703 16H14.923C15.3319 16 15.6996 16.249 15.8514 16.6286L17.7 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H6.3L8.14856 16.6286C8.30042 16.249 8.66813 16 9.07703 16ZM12 20.5C12.8284 20.5 13.5 19.8284 13.5 19C13.5 18.1716 12.8284 17.5 12 17.5C11.1716 17.5 10.5 18.1716 10.5 19C10.5 19.8284 11.1716 20.5 12 20.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuicer);
export default __webpack_public_path__ + "static/media/juicer.4ce11ac22a606b6903362a5e604c7d3e.svg";
export { ForwardRef as ReactComponent };